// Renders the Amanda's Home Improvement wordmark in the brand serif (Fraunces).
// Replaces the former image logo. The component name, props and export are
// unchanged so every import site keeps working.
//
// Unlike an image, text must not scale with `height` — a large height once blew
// the font size up so far the wordmark overflowed the sidebar and collided with
// the page header. So the font size is CAPPED at a sensible ceiling, the span is
// bounded to its parent's width, and it wraps onto a second line (or, if forced,
// truncates with an ellipsis) rather than spilling out.
export default function CprLogo({ height = 26, rounded = 6, style = {} }) {
  // Height only nudges the size; it can never push past the cap.
  const fontSize = Math.min(Math.max(Math.round(height * 0.55), 13), 20);
  return (
    <span
      style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 600,
        fontSize,
        lineHeight: 1.12,
        letterSpacing: '-0.01em',
        color: 'var(--gray-900)',
        display: 'block',
        maxWidth: '100%',
        borderRadius: rounded,
        // Fit the container: wrap to two lines when narrow, and clip with an
        // ellipsis as a last resort so the text can never escape its parent.
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      Amanda's Home Improvement
    </span>
  );
}
